module.exports = __webpack_public_path__ + "img/Jackets@2x.9c30ada2.png";